import React, { useState, useEffect } from 'react';
import { Link } from '../basic/Links';
import { Announce } from 'react-magma-dom';
import { FormHeader } from '../basic/FormHeader';

export const TEST_ID = {
  message: 'redirect-step-message'
};

interface RedirectInfo {
  redirectTo: string;
  seconds: number;
}

export interface RedirectStepProps {
  redirectTo: string;
  messageGen?: (info: RedirectInfo) => React.ReactNode;
}

export const RedirectStep: React.FC<RedirectStepProps> = props => {
  const {
    redirectTo,
    messageGen = info => (
      <>
        <FormHeader>You're Registered!</FormHeader>
        <p
          style={{
            textAlign: 'center',
            width: '100%'
          }}
        >
          You are being redirected to your original location in {info.seconds}{' '}
          seconds...
        </p>
      </>
    )
  } = props;

  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    const id = setInterval(() => setSeconds(o => Math.max(o - 1, 0)), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (0 >= seconds) {
      /* istanbul ignore next */
      (window as any).location = redirectTo;
    }
  }, [redirectTo, seconds]);

  return (
    <>
      <Announce>
        <div data-testid={TEST_ID.message}>
          {messageGen({ redirectTo, seconds })}
        </div>
      </Announce>
      <div style={{ textAlign: 'center' }}>
        <Link href={redirectTo}>
          Click here if you are not automatically redirected
        </Link>
      </div>
    </>
  );
};
